import { Injectable } from '@angular/core'
import {
  HttpClient
} from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable()
export class TransactionService {
  url: string | null = null
  constructor (private http: HttpClient) {
    this.url = environment.baseApiUrl + 'admin/'
  }

  getAll () {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + 'transactions'
          : environment.baseApiUrlTest + 'transactions'
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  get (transactionRef: string): Observable<any> {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + 'transactions/' + transactionRef
          : environment.baseApiUrlTest + 'transactions/' + transactionRef
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  getTransactionsWithStatus (status: string): Observable<any> {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + 'transaction/' + status
          : environment.baseApiUrlTest + 'transaction/' + status
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  filter (data: any): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'transactions/filter'
          : environment.baseApiUrlTest + 'transactions/filter',
        data
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  statistics (permission: string, agentID: string): Observable<any> {
    if (permission === 'agent') {
      return this.http
        .get(
          environment.production
            ? environment.baseApiUrl +
                `system/transactions/statistics/${agentID}`
            : environment.baseApiUrlTest +
                `system/transactions/statistics/${agentID}`
        )
        .pipe(
          map((response: any) => {
            return response['data']
          })
        )
    } else {
      return this.http
        .get(
          environment.production
            ? environment.baseApiUrl + `system/transactions/statistics`
            : environment.baseApiUrlTest + `system/transactions/statistics`
        )
        .pipe(
          map((response: any) => {
            return response['data']
          })
        )
    }
  }

  getBalance (slug: string) {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + `agent/${slug}/`
          : environment.baseApiUrlTest + `agent/${slug}/`
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  retryTransaction (transaction_ref: string) {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + `retry-transaction/${transaction_ref}`
          : environment.baseApiUrlTest + `retry-transaction/${transaction_ref}/`,
        {}
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }

  editTransaction (transaction_ref: string, data: any) {
    const baseUrl = environment.production
      ? environment.baseApiUrl
      : environment.baseApiUrlTest

    return this.http
      .patch(`${baseUrl}edit-transaction/${transaction_ref}`, data)
      .pipe(map((response: any) => response))
  }
}
